// import { Backdrop, CircularProgress } from "@mui/material";
// import { useEffect, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";

// export const NavigationLoader = () => {
//   const location = useLocation();
//   const [isLoading, setIsLoading] = useState(false);
//   const prevPathname = useRef(location.pathname);

//   useEffect(() => {
//     if (prevPathname.current !== location.pathname) {
//       prevPathname.current = location.pathname;
//       setIsLoading(true);
//     }
//   }, [location.pathname]);

//   useEffect(() => {
//     if (isLoading) {
//       const frame = requestAnimationFrame(() => {
//         setTimeout(() => setIsLoading(false), 300);
//       });
//       return () => cancelAnimationFrame(frame);
//     }
//   }, [location.pathname, isLoading]);

//   return (
//     <Backdrop
//       open={isLoading}
//       sx={{
//         zIndex: 1200,
//         backgroundColor: "rgba(255,255,255,0.4)",
//         backdropFilter: "blur(4px)",
//       }}
//     >
//       <CircularProgress color="primary" size={48} thickness={4} />
//     </Backdrop>
//   );
// };

// import { Backdrop, CircularProgress } from "@mui/material";
// import { useLoading } from "./LoadingContext";

// export const NavigationLoader = () => {
//   const { isLoading } = useLoading();
//   return (
//     <Backdrop
//       open={isLoading}
//       sx={{
//         zIndex: 1200,
//         backgroundColor: "rgba(255,255,255,0.4)",
//         backdropFilter: "blur(4px)",
//       }}
//     >
//       <CircularProgress color="primary" size={48} thickness={4} />
//     </Backdrop>
//   );
// };

import { Backdrop, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const NavigationLoader = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest("a");
      if (!target) return;

      const href = target.getAttribute("href");
      if (!href || href === location.pathname) return;
      if (href.startsWith("http") || href.startsWith("mailto") || href.startsWith("blob:") || href.startsWith("data:")) return;

      setIsLoading(true);
    };

    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, [location.pathname]);

  useEffect(() => {
    setIsLoading(false);
  }, [location.pathname]);

  return (
    <Backdrop
      open={isLoading}
      sx={{
        zIndex: 1200,
        backgroundColor: "rgba(255,255,255,0.4)",
        backdropFilter: "blur(4px)",
      }}
    >
      <CircularProgress color="primary" size={48} thickness={4} />
    </Backdrop>
  );
};